import { Component, Input, OnInit } from '@angular/core';
import { Job } from '../../jobs.models';
import { JobsResource } from '../../resources/jobs.resource';
import { PackageVariable, PackageVariablesService } from '../../services/package-variables.service';

function checkDeserializeFromJson(userVariables: any[]): any[] {
  return userVariables.map((userVariable) => {
    if (userVariable.value.indexOf('DeserializeFromJson') > -1) {
      try {
        // eslint-disable-next-line no-eval
        return { ...userVariable, value: eval(userVariable.value) };
      } catch (e) {
        return userVariable;
      }
    }
    return userVariable;
  });
}

@Component({
  selector: 'job-variables',
  template: `
    <div class="job-variables job-content">
      <div class="package-variables-editor variables-editor" *ngIf="!areVariablesLoading">
        <div class="package-variables-editor-body">
          <div class="package-variables-editor-tabs-box">
            <div class="package-variables-editor-tabs">
              <div [ngClass]="{ active: isUserVariables }" (click)="isUserVariables = true"><span>User</span></div>
              <div [ngClass]="{ active: !isUserVariables }" (click)="isUserVariables = false"><span>System</span></div>
            </div>
            <div class="package-variables-editor-content">
              <div *ngIf="isUserVariables" [ngClass]="{ active: isUserVariables }">
                <div class="variables-editor variables-editor-wrapper">
                  <div class="variables-editor-headers">
                    <div class="variables-editor-header variables-variable">
                      <span>{{ 'job-view.variables.headers.variable' | translate }} </span>
                    </div>
                    <div class="variables-editor-header variables-expression">
                      <span>{{ 'job-view.variables.headers.expression' | translate }} </span>
                    </div>
                  </div>
                  <div
                    class="variables-editor-row string"
                    *ngFor="let userVariable of userVariables; let index = index"
                  >
                    <div class="variables-editor-row-number">{{ index | xpIndex }}</div>
                    <div class="variables-editor-cell variables-editor-move locked">
                      <button class="btn btn-defaut btn-lg" tabindex="-1" disabled="disabled">
                        <svg width="15px" height="16.5px" viewBox="0 0 15 16.5">
                          <g id="icon-list-lock_1_">
                            <path
                              style="fill: none; stroke: #999999; stroke-width: 2; stroke-miterlimit: 10;"
                              d="M3,5.5C3,3,5,1,7.5,1S12,3,12,5.5"
                            ></path>
                            <path
                              style="fill: #999999;"
                              d="M13.9,5.5H1.1C0.5,5.5,0,6,0,6.6v8.9c0,0.6,0.5,1.1,1.1,1.1h12.9c0.6,0,1.1-0.5,1.1-1.1V6.6 C15,6,14.5,5.5,13.9,5.5z M8,11.4v2.1H7v-2.1c-0.6-0.2-1-0.8-1-1.4c0-0.8,0.7-1.5,1.5-1.5S9,9.2,9,10C9,10.7,8.6,11.2,8,11.4z"
                            ></path>
                          </g>
                        </svg>
                      </button>
                    </div>
                    <div class="variables-editor-cell-input variables-editor-key variables-editor-cell-padding">
                      <div class="cell-container">
                        <input
                          type="text"
                          class="form-control input-lg"
                          readonly="readonly"
                          value="{{ userVariable.key }}"
                        />
                      </div>
                    </div>
                    <div class="variables-editor-cell-input">
                      <div class="cell-container">
                        <input
                          type="text"
                          class="form-control input-lg"
                          readonly="readonly"
                          value="{{ userVariable.value }}"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="!isUserVariables" [ngClass]="{ active: !isUserVariables }">
                <div class="variables-editor variables-editor-wrapper">
                  <div class="variables-editor-headers">
                    <div class="variables-editor-header variables-variable">
                      <span>{{ 'job-view.variables.headers.variable' | translate }} </span>
                    </div>
                    <div class="variables-editor-header variables-expression">
                      <span>{{ 'job-view.variables.headers.expression' | translate }} </span>
                    </div>
                  </div>
                  <div
                    class="variables-editor-row string"
                    *ngFor="let systemVariable of systemVariables; let index = index"
                  >
                    <div class="variables-editor-row-number">{{ index | xpIndex }}</div>
                    <div class="variables-editor-cell variables-editor-move locked">
                      <button class="btn btn-defaut btn-lg" tabindex="-1" disabled="disabled">
                        <svg width="15px" height="16.5px" viewBox="0 0 15 16.5">
                          <g id="icon-list-lock_1_">
                            <path
                              style="fill: none; stroke: #999999; stroke-width: 2; stroke-miterlimit: 10;"
                              d="M3,5.5C3,3,5,1,7.5,1S12,3,12,5.5"
                            ></path>
                            <path
                              style="fill: #999999;"
                              d="M13.9,5.5H1.1C0.5,5.5,0,6,0,6.6v8.9c0,0.6,0.5,1.1,1.1,1.1h12.9c0.6,0,1.1-0.5,1.1-1.1V6.6 C15,6,14.5,5.5,13.9,5.5z M8,11.4v2.1H7v-2.1c-0.6-0.2-1-0.8-1-1.4c0-0.8,0.7-1.5,1.5-1.5S9,9.2,9,10C9,10.7,8.6,11.2,8,11.4z"
                            ></path>
                          </g>
                        </svg>
                      </button>
                    </div>
                    <div class="variables-editor-cell-input variables-editor-key variables-editor-cell-padding">
                      <div class="cell-container">
                        <input
                          type="text"
                          class="form-control input-lg"
                          readonly="readonly"
                          value="{{ systemVariable.key }}"
                        />
                      </div>
                    </div>
                    <div class="variables-editor-cell-input">
                      <div class="cell-container">
                        <input
                          type="text"
                          class="form-control input-lg"
                          readonly="readonly"
                          value="{{ systemVariable.value }}"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <xp-loader *ngIf="areVariablesLoading"></xp-loader>
    </div>
  `,
})
export class JobVariablesComponent implements OnInit {
  @Input() item: Job;

  userVariables: PackageVariable[];
  systemVariables: PackageVariable[];
  areVariablesLoading = true;
  isUserVariables = true;

  constructor(private jobsResource: JobsResource, private packageVariablesService: PackageVariablesService) {}

  ngOnInit() {
    this.jobsResource.variables(this.item.id).subscribe(
      (variables) => {
        this.packageVariablesService.separateVariables(variables, true, (variablesObject) => {
          this.userVariables = checkDeserializeFromJson(variablesObject.userVariables);
          this.systemVariables = variablesObject.systemVariables;
        });
        this.areVariablesLoading = false;
      },
      () => {
        this.areVariablesLoading = false;
      },
    );
  }
}
